import PropTypes from "prop-types";

export const MARK_UP_APPLY_TO_TYPES = {
  retailPrice: "retailPrice",
  cost: "cost",
  retailPriceAndCost: "retailPriceAndCost",
  shippingCost: "shippingCost",
}

const markUpItemInterface = {
  id: PropTypes.string, // uuid
  type: PropTypes.string, // "mark_up" || "mark_down"
  priceType: PropTypes.string, // "currency" || "percentage"
  applyTo: PropTypes.oneOf(Object.keys(MARK_UP_APPLY_TO_TYPES)), // dropdown
  value: PropTypes.number, // 10 increase or decrease value, main property
  created: PropTypes.number, // 1682589331 (unix date)
  updated: PropTypes.number, // 1682589331 (unix date)
  originalValues: PropTypes.object, // this is only feature used property! {cost: 10, price: 20, shippingCost: 50}
  forUnlinkedCatId: PropTypes.number, // 1517
};

export const defaultMarkUpItem = {
  id: 0, // dynamic
  type: "mark_up",
  priceType: "price",
  applyTo: MARK_UP_APPLY_TO_TYPES.retailPrice, // depends on current
  value: 0,
  created: 0, // dynamic
  updated: 0, // dynamic
  originalValues: {}, // this is only feature used property!
};

export default markUpItemInterface
